import React from 'react';
import { HtmlElementDefaults } from '../../type/HtmlElementDefaults';
import clsx from 'clsx';
import { Styles } from '../../type/Styles';
import './XSIcon.css';

export type XSIconInput = Omit<HtmlElementDefaults, 'children'> & {
    color?: Styles.Color | 'ghost';
    size?: number;
    children: string | React.ReactNode;
};

export function XSIcon(input: XSIconInput) {
    const { className, color, size, children } = input;
    const style = input.style || {};

    if (size) {
        style.fontSize = size;
        style.height = size;
        style.width = size;
    }

    if (typeof children === 'string') {
        return (
            <span className={clsx(className, `XSIcon material-symbols-outlined color-${color || ''}`)} style={style}>
                {children}
            </span>
        );
    }

    return (
        <span className={clsx(className, `XSIcon color-${color || ''}`)} style={style}>
            {children}
        </span>
    );
}
